"use client";
import React, { useCallback, useEffect, useState } from "react";
import Button from "@/common/Button";
import DropdownMenu from "@/common/DropdownMenu";
import PriceInput from "@/common/PriceInput";
import ArrowDropdown from "../Svg/ArrowDropdown";
import {
  brandMenuType,
  categoryMenuType,
  CategorySearchFilterType,
} from "@/types/Search";
import { useMutation } from "@tanstack/react-query";
import { getCategoryTreeView } from "@/services/categoryCardService";
import { getBrandData } from "@/services/getBrandData";
import { useRouter } from "next/navigation";
import CategorySearchMenu from "../Search/CategorySearchMenu";
import BrandSearchMenu from "../Search/BrandSearchMenu";
import FilterIcon from "../Svg/FilterIcon";
import Sortable from "../Svg/Sortable";
import Modal from "@/common/Modal";
import CloseBasketIcon from "../Svg/CloseBasketIcon";
import SearchFilterCollapse from "./SearchFilterCollapse";

function SearchFilter({
  minValue,
  maxValue,
  setMinValue,
  setMaxValue,
  setCheckedItems,
  filterCount,
  checkedItems,
  MAX_VALUE,
  checkedBrandItems,
  setCheckedBrandItems,
  Categorykeys,
  setSortOrder,
  setSortType,
  sortType,
  sortOrder,
  checkedNames,
  setCheckedNames,
  checkedBrandNames,
  setCheckedBrandNames,
}: CategorySearchFilterType) {
  const [categoryMenuData, setCategoryMenuData] = useState<categoryMenuType[]>(
    []
  );
  // const searchParams = useSearchParams();
  // const specificValue = searchParams.get("q") || "";
  // const finalSearchValue = decodeURIComponent(specificValue);
  const [brandMenuData, setBrandMenuData] = useState<brandMenuType[]>([]);
  const router = useRouter();

  const { mutateAsync: getCategoryForSearch } = useMutation({
    mutationFn: getCategoryTreeView,
    retry: 2,
    retryDelay: 1000,
  });
  const { mutateAsync: getBrandForSearch } = useMutation({
    mutationFn: getBrandData,
    retry: 2,
    retryDelay: 1000,
  });
  const getAllCategoryData = useCallback(async () => {
    try {
      const response = await getCategoryForSearch({
        selected: true,
        // text: finalSearchValue,
      });
      if (response?.isSuccess) {
        setCategoryMenuData(response?.data);
      }
    } catch (err) {
      console.log("Error in fetching products:", err);
    }
  }, [getCategoryForSearch]);
  const getAllBrandData = useCallback(async () => {
    const categoryIds = Categorykeys ?? [0];
    try {
      const response = await getBrandForSearch({
        categoryIds,
      });
      if (response?.isSuccess) {
        setBrandMenuData(response?.data);
      }
    } catch (err) {
      console.log("error in get Brand Data: ", err);
    }
  }, [getBrandForSearch, Categorykeys]);

  useEffect(() => {
    getAllCategoryData();
    getAllBrandData();
  }, [getAllCategoryData, getAllBrandData]);

  const resetFilter = () => {
    setCheckedItems({});
    setCheckedBrandItems({});
    setMinValue(0);
    setMaxValue(MAX_VALUE);
    router.refresh();
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const handleCloseModal = () => {
    setIsMenuOpen(false);
  };
  const flexItems = `flex items-center`;

  return (
    <>
      <div className="mt-10 bg-ws-grayBlue-100 p-2 rounded-2xl  justify-between items-center sm:flex hidden">
        <div className="flex gap-3 items-center">
          <CategorySearchMenu
            setCategoryMenuData={setCategoryMenuData}
            checkedItems={checkedItems}
            categoryMenuData={categoryMenuData}
            getCategoryForSearch={getCategoryForSearch}
            setCheckedItems={setCheckedItems}
            checkedNames={checkedNames}
            setCheckedNames={setCheckedNames}
          />

          <BrandSearchMenu
            brandMenuData={brandMenuData}
            checkedBrandItems={checkedBrandItems}
            getBrandForSearch={getBrandForSearch}
            setCheckedBrandItems={setCheckedBrandItems}
            setBrandMenuData={setBrandMenuData}
            checkedBrandNames={checkedBrandNames}
            setCheckedBrandNames={setCheckedBrandNames}
          />

          <DropdownMenu
            direction="rtl"
            menuClass="p-0 border top-14 right-0"
            customeClass="w-max py-1 px-1 rounded-lg bg-white"
            trigger={
              <Button variant="primary" className="h-8 px-3">
                <span className=" ws-gray-500  text-lg">{"قیمت"}</span>
                <ArrowDropdown />
              </Button>
            }
          >
            <div className="bg-white w-80 rounded-xl p-3">
              <PriceInput
                minValue={minValue}
                maxValue={maxValue}
                setMinValue={setMinValue}
                setMaxValue={setMaxValue}
                MAX_VALUE={MAX_VALUE}
              />
            </div>
          </DropdownMenu>
        </div>
        <div className="flex items-center gap-3">
          {/* <div className="bg-white w-14  p-1 flex items-center justify-center  rounded-lg">
            <span className="bg-ws-grayBlue-600 text-white num-vazir w-full p-1 text-lg rounded-lg text-center h-full scale-animation">
              {filterCount}
            </span>
          </div> */}
          <Button className="text-ws-grayBlue-600 px-5 py-2 bg-white rounded-lg">
            <span onClick={resetFilter} className="text-lg font-thin">
              {"پاک کردن فیلترها"}
            </span>
          </Button>
        </div>
      </div>
      <div className="mt-5 bg-ws-grayBlue-100 p-2 px-12 mobile-filter-wrapper py-3   justify-between items-center sm:hidden flex">
        <Button
          onClick={() => setIsMenuOpen((prev) => !prev)}
          className="text-ws-gray-500 py-[10px] px-10 rounded-2xl bg-white "
        >
          <FilterIcon className="w-4 h-4" />
          <span className="text-lg ">فیلترها</span>
        </Button>

        <DropdownMenu
          direction="rtl"
          menuClass="p-0 border top-14 -right-10 dropdown-filter"
          customeClass="w-max py-2 px-5 rounded-2xl  bg-white"
          trigger={
            <Button variant="primary" className="h-8 px-3">
              <Sortable className="w-5 h-5" />
              <span className=" ws-gray-500  text-lg">{"مرتب‌سازی"}</span>
            </Button>
          }
        >
          <div className="flex flex-col w-[250px] items-center gap-5 py-5 ">
            <span
              onClick={() => handleSort(1, false)}
              className={`cursor-pointer ${
                sortType === 1 && sortOrder === false
                  ? "active text-ws-grayBlue-600"
                  : ""
              }`}
            >
              مرتبط‌ترین
            </span>

            <span
              onClick={() => {
                setSortType(3);
                setSortOrder(false);
              }}
              className={`cursor-pointer ${
                sortType === 3 && sortOrder === false
                  ? "active text-ws-grayBlue-600"
                  : ""
              }`}
            >
              جدید‌ترین
            </span>

            <span
              onClick={() => {
                setSortType(2);
                setSortOrder(false);
              }}
              className={`cursor-pointer ${
                sortType === 2 && sortOrder === false
                  ? "active text-ws-grayBlue-600"
                  : ""
              }`}
            >
              ارزان‌ترین
            </span>

            <span
              onClick={() => {
                setSortType(2);
                setSortOrder(true);
              }}
              className={`cursor-pointer ${
                sortType === 2 && sortOrder === true
                  ? "active text-ws-grayBlue-600"
                  : ""
              }`}
            >
              گران‌ترین
            </span>

            <span
              onClick={() => {
                setSortType(4);
              }}
              className={`cursor-pointer ${
                sortType === 4 ? "active text-ws-grayBlue-600" : ""
              }`}
            >
              آفرهای ویژه
            </span>
          </div>
        </DropdownMenu>
      </div>

      <Modal
        backdrop={false}
        backdropClosable
        modalCustomClass="top-0 z-[2000] rounded-none modal-filter"
        isOpen={isMenuOpen}
        enterFrom="right"
        position="rightFull"
        modalTitleClass="flex justify-between w-full "
        size="medium"
        modalTitle={
          <>
            <div className="flex items-center w-full justify-between ">
              <h2 className="text-xl lg:text-xl text-ws-gray-700 ">فیلتر ها</h2>
              <CloseBasketIcon
                className="cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              />
            </div>
          </>
        }
        modalHeaderClass=" px-5 text-lg  text-ws-gray-700 px-10 pt-8 border-b-0"
        onClose={handleCloseModal}
        modalBodyClass="modal-body-header modal-px-0  "
      >
        <>
          <div
            className={`${flexItems} justify-between flex-col  search-filter-mobile  `}
          >
            <SearchFilterCollapse
              setSortOrder={setSortOrder}
              setSortType={setSortType}
              sortType={sortType}
              sortOrder={sortOrder}
              setCategoryMenuData={setCategoryMenuData}
              checkedItems={checkedItems}
              categoryMenuData={categoryMenuData}
              getCategoryForSearch={getCategoryForSearch}
              setCheckedItems={setCheckedItems}
              brandMenuData={brandMenuData}
              checkedBrandItems={checkedBrandItems}
              getBrandForSearch={getBrandForSearch}
              setCheckedBrandItems={setCheckedBrandItems}
              setBrandMenuData={setBrandMenuData}
              minValue={minValue}
              maxValue={maxValue}
              setMinValue={setMinValue}
              setMaxValue={setMaxValue}
              MAX_VALUE={MAX_VALUE}
              setIsMenuOpen={setIsMenuOpen}
              resetFilter={resetFilter}
              filterCount={filterCount}
            />
          </div>
        </>
      </Modal>
    </>
  );
}

export default SearchFilter;
